export enum ETouchEvent {
  DEMO_1 = 'DEMO_1',
}

export enum ETouchEventTriggerId {
  DEMO_TOUCH_EVENT_BTN = 'DEMO_TOUCH_EVENT_BTN',
}
